<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        :todo-list.sync="todoList"
        show-to-do
        @reloadData="requestData()"
        @task="taskFun"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.schemeNo"
              placeholder="请输入方案编号"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.schemeName"
              placeholder="请输入方案名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.materialsName"
              placeholder="请输入物料名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col
            :xs="12"
            :sm="8"
            :md="6"
            :lg="4"
            :xl="3"
          >
            <el-button
              type="primary"
              @click="searchData()"
            >
              搜索
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @export="batchExport(masterList)"
        @edit="editFun(arguments)"
        @dblclick="viewFun(arguments)"
        @view="viewFun(arguments)"
        @delete="deleteFun(arguments)"
        @check="checkFun(arguments)"
        @unCheck="unCheckFun(arguments)"
      />
    </div>
    <!-- 待办列表 -->
    <task-list-dialog
      :dialog-visible.sync="dialogTaskVisible"
      dialog-title="待回访清单"
      @reloadData="loadTableData()"
    />
    <!-- 修改-->
    <add-edit-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogAddEditTitle"
      :dialog-visible.sync="dialogAddEditVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
    <!-- 查看 -->
    <view-dialog
      :data-id="id"
      :dialog-title="dialogViewTitle"
      :dialog-visible.sync="dialogViewVisible"
      :master-table-key="masterList.tableKey"
    />
    <!-- 复核 -->
    <check-dialog
      :data-id="id"
      :dialog-title="'复核回访记录'"
      :dialog-visible.sync="dialogCheckVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 定义表头颜色，高度，搜索，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 待办事件轮询请求 todoListLoopMixin
import todoListLoopMixin from '@/mixin/todoListLoopMixin'
// 修改
import AddEditDialog from './components/addEditDialog'
// 查看
import ViewDialog from './components/viewDialog'
// 复核
import checkDialog from './components/checkDialog'
// 待办列表
import taskListDialog from './components/taskListDialog'
// 数据请求
import { loadCallBackBillListDataApi, loadCallBackBillExportDataApi, findCallBackPendingTaskCountApi, saveOrUpdateCallBackBillApi } from '@/api/callBackBill'
export default {
  name: 'CallBackBill',
  components: {
    CustomTable,
    TableOperation,
    AddEditDialog,
    taskListDialog,
    ViewDialog,
    checkDialog
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin, todoListLoopMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'call_back_bill_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['call_back_bill_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['call_back_bill_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['call_back_bill_del'],
            prop: 'delete',
            label: '作废',
            method: 'delete'
          },
          {
            permissionSigns: ['call_back_bill_check'],
            prop: 'check',
            label: '复核',
            method: 'check'
          },
          {
            permissionSigns: ['call_back_bill_unCheck'],
            prop: 'unCheck',
            label: '反复核',
            method: 'unCheck'
          },
          {
            permissionSigns: ['call_back_bill_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            schemeNo: '',
            schemeName: '',
            materialsName: ''
          }
        }
      },
      id: null, // 选中的单据ID
      // 待办
      todoList: [
        {
          permissionSigns: ['call_back_bill_add'],
          label: '待回访清单',
          method: 'task',
          count: 0
        }
      ],
      dialogTaskVisible: false,
      eventType: '',
      dialogAddEditTitle: '',
      dialogAddEditVisible: false,
      dialogViewTitle: '查看回访记录',
      dialogViewVisible: false,
      dialogCheckVisible: false
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceName', label: '省区', filterColumn: 'db.province_name', width: 80 },
      { prop: 'cityName', label: '城市', filterColumn: 'db.city_name', width: 80 },
      { prop: 'storeName', label: '终端名称', filterColumn: 'db.store_name', width: 160 },
      { prop: 'ownerName', label: '联系人', filterColumn: 'db.owner_name', width: 130 },
      { prop: 'phone', label: '联系电话', filterColumn: 'db.phone', width: 130 },
      { prop: 'receiver', label: '物料发放人', filterColumn: 'db.receiver', width: 120 },
      { prop: 'visitDateStr', label: '发放时间', filterColumn: 'db.visit_date', width: 110 },
      { prop: 'materialsName', label: '发放物料名称', filterColumn: 'db.materials_name', width: 180 },
      { prop: 'unitName', label: '单位', filterColumn: 'db.unit_name', width: 80 },
      { prop: 'amount', label: '发放数量', filterColumn: 'db.amount', width: 110 },
      { prop: 'callBackUserName', label: '回访人', filterColumn: 'db.call_back_user_name', width: 110 },
      { prop: 'callBackDateStr', label: '回访时间', filterColumn: 'db.call_back_date', width: 110 },
      { prop: 'callBackMethodStr', label: '回访方式', filterColumn: '(case db.call_back_method when 1 then "电话" when 2 then "现场" else "" end)', width: 110 },
      { prop: 'callBackResultStr', label: '回访结果', filterColumn: '(case db.call_back_result when 1 then "结果属实" when 2 then "无法回忆或记不清" when 3 then "没有收到此物料" when 4 then "收到数量不对" else "" end)', width: 140 },
      { prop: 'dealOpinion', label: '处理意见', filterColumn: 'db.deal_opinion', width: 160 },
      { prop: 'statusStr', label: '状态', filterColumn: '(case db.status when 1 then "制单" when 2 then "复核" else "" end)', width: 80 },
      { prop: 'remark', label: '备注', filterColumn: 'db.remark', width: 180 },
      { prop: 'operatorName', label: '回访人', filterColumn: 'db.operator_mame', width: 110 },
      { prop: 'operationTimeStr', label: '回访时间', filterColumn: 'db.operation_time', width: 160, isBetween: true },
      { prop: 'checkName', label: '复核人', filterColumn: 'db.check_mame', width: 110 },
      { prop: 'checkTimeStr', label: '复核时间', filterColumn: 'db.check_time', width: 160, isBetween: true },
      { prop: 'checkOpinion', label: '复核意见', filterColumn: 'db.check_opinion', width: 160 }
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      loadCallBackBillListDataApi(pageCondition).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
      this.getTodoCount()
    },
    // 获取待办任务数量
    getTodoCount () {
      findCallBackPendingTaskCountApi().then(res => {
        this.todoList[0].count = res.data ? res.data : 0
      })
    },
    // 代办
    taskFun () {
      this.dialogTaskVisible = !this.dialogTaskVisible
    },
    // 修改
    editFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      } else if (args[0].status !== 1) {
        this.$message({
          message: '单据不是制单状态，不能修改',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.eventType = 'edit'
      this.dialogAddEditVisible = !this.dialogAddEditVisible
      this.dialogAddEditTitle = '修改回访记录'
    },
    // 查看
    viewFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.eventType = 'view'
      this.dialogViewVisible = !this.dialogViewVisible
    },
    // 作废
    deleteFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      } else if (args[0].status !== 1) {
        this.$message({
          message: '单据不是制单状态，不能作废',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.$confirm('是否确定作废该回访记录？', '系统提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }
      ).then(async () => {
        saveOrUpdateCallBackBillApi({ id: args[0].id, status: 0, isDel: "1" }).then(res => {
          if (res.mark === '200') {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 复核
    checkFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      } else if (args[0].status !== 1) {
        this.$message({
          message: '单据不是制单状态，不能复核',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.dialogCheckVisible = !this.dialogCheckVisible
    },
    // 反复核
    unCheckFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      } else if (args[0].status !== 2) {
        this.$message({
          message: '单据不是复核状态，不能反复核',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.$confirm('是否确定反复核该回访记录？', '系统提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }
      ).then(async () => {
        saveOrUpdateCallBackBillApi({ id: args[0].id, isUnCheck: "1" }).then(res => {
          if (res.mark === '200') {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadCallBackBillExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
